import { useState } from "react";
import LabelsLayout from "../componants/labels/LabelsLayout";
import LabelBreadcrumb from "../componants/labels/LabelBreadcrumb";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ChevronDown, SlidersHorizontal } from "lucide-react";
import LabelSearchForm from "../componants/labels/LabelSearchForm";

const contentVariants = {
  hidden: { height: 0, opacity: 0 },
  visible: { height: "auto", opacity: 1 },
};

const options = [
  { id: "Certificats", name: "Certificats" },
  { id: "Certificats refusés", name: "Certificats refusés" },
];

export default function CertificatOrganismeSearch() {
  const [isOpen, setIsOpen] = useState(true);
  const [selected, setSelected] = useState("Certificats");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    organisme: "",
    entityId: "",
    entityName: "",
    version: "",
    reference: "",
    types: "",
    startDate: "",
    endDate: "",
    status: "",
    isHistory: false,
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const searchHandler = () => {
    navigate("/certificats/organismes", { state: formData });
  };

  const toggleOpen = () => setIsOpen((prev) => !prev);

  const intialisationHandler = () => {
    setFormData({
      organisme: "",
      entityId: "",
      entityName: "",
      version: "",
      reference: "",
      types: "",
      startDate: "",
      endDate: "",
      status: "",
      isHistory: false,
    });
  };

  return (
    <LabelsLayout>
      <section className="container mx-auto">
        <LabelBreadcrumb title={"Certificats Organismes"} />
        <div className=" pt-5 pb-10 px-6">
          <LabelSearchForm
            selected={selected}
            setSelected={setSelected}
            isOpen={isOpen}
            toggleOpen={toggleOpen}
            options={options}
            formData={formData}
            handleChange={handleChange}
            searchHandler={searchHandler}
            intialisationHandler={intialisationHandler}
          />
        </div>{" "}
      </section>
    </LabelsLayout>
  );
}
